import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=6032ef1a"
import script from "./Like.vue?vue&type=script&lang=js"
export * from "./Like.vue?vue&type=script&lang=js"
import style0 from "./Like.vue?vue&type=style&index=0&id=6032ef1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports